import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import CountAdjIndexActions, { CountAdjIndexTypes } from '../Stores/CountAdjIndex/Actions';

const getAppStore = state => state.app;

export function* countAdjIndexFetchCountAdjIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(CountAdjIndexActions.countAdjIndexFetchCountAdjIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `countAdj/index/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        CountAdjIndexActions.countAdjIndexFetchCountAdjIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdjIndexActions.countAdjIndexFetchCountAdjIndexLoading(false));
  }
}

export function* countAdjIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/countAdjDetail/update/${hdrId}`));
}

export function* countAdjIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/COUNT_ADJ/${hdrId}/CountAdjHdr`));
}

export function* countAdjIndexNewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/countAdjDetail/create/${app.curSiteFlowId}`));
}

export function* countAdjIndexGoToPrint({ document }) {
  try {
    yield put(CountAdjIndexActions.countAdjIndexFetchCountAdjIndexLoading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds: [document.id]
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `countAdj/print/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, `CountAdj_${document.doc_code}.pdf`);
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdjIndexActions.countAdjIndexFetchCountAdjIndexLoading(false));
  }
}

export function* countAdjIndexResetCountAdjSync01({ hdrIds }) {
  try {
    yield put(CountAdjIndexActions.countAdjIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `countAdj/syncProcess/RESET_COUNT_ADJ_SYNC_01/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(CountAdjIndexActions.countAdjIndexResetCountAdjSync01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdjIndexActions.countAdjIndexWorkspaceLoading(false));
  }
}

export function* countAdjIndexResetCountAdjFServ01({ hdrIds }) {
  try {
    yield put(CountAdjIndexActions.countAdjIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      divisionId: app.curDivisionId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `countAdj/fServProcess/RESET_COUNT_ADJ_F_SERV_01/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(CountAdjIndexActions.countAdjIndexResetCountAdjSync01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdjIndexActions.countAdjIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(CountAdjIndexTypes.COUNT_ADJ_INDEX_GO_TO_DOCUMENT, countAdjIndexGoToDocument),
  takeLatest(CountAdjIndexTypes.COUNT_ADJ_INDEX_GO_TO_AUDIT, countAdjIndexGoToAudit),
  takeLatest(
    CountAdjIndexTypes.COUNT_ADJ_INDEX_FETCH_COUNT_ADJ_INDEX,
    countAdjIndexFetchCountAdjIndex
  ),
  takeLatest(CountAdjIndexTypes.COUNT_ADJ_INDEX_NEW_DOCUMENT, countAdjIndexNewDocument),
  takeLatest(CountAdjIndexTypes.COUNT_ADJ_INDEX_GO_TO_PRINT, countAdjIndexGoToPrint),

  takeLatest(
    CountAdjIndexTypes.COUNT_ADJ_INDEX_RESET_COUNT_ADJ_SYNC01,
    countAdjIndexResetCountAdjSync01
  ),

  takeLatest(
    CountAdjIndexTypes.COUNT_ADJ_INDEX_RESET_COUNT_ADJ_F_SERV01,
    countAdjIndexResetCountAdjFServ01
  )
];
